import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Logo from "../../../assets/lime_logo_white.png";
import { isTablet, isDesktop } from "react-device-detect";
import Header from "../../../components/Header";
import classes from "./AuthLayout.module.scss";
import useWindowDimensions from '../../../hooks/Window';
import './AuthLayout.module.scss';

const AuthLayout = ({ children, title, subtitle }: any) => {
  const windowDimensions = useWindowDimensions();
  const isLandscape = windowDimensions.width > windowDimensions.height;

  return (
    <Grid container className={classes.root} spacing={0}>
      {(isDesktop || (isTablet && isLandscape)) ? (
        <Grid className={classes.bgContainer}>
          <img src={Logo} alt="Lime Logo" className={classes.logo} />
        </Grid>
      ) : (
        <Header disableMenu />
      )}
      <main className={classes.authContainer}>
        <Grid container size={10} direction="column" maxWidth={"400px"}>
          <Grid size={12}>
            <Box component="p" m={1} className='subtitle' paddingTop={'2em'}>
              {subtitle}
            </Box>
          </Grid>
          <Grid size={12}>
            <Box component="h1" m={1} className='title'>
              {title}
            </Box>
          </Grid>
          <br></br>
          <Grid size={12}>
            {children}
          </Grid>
        </Grid>
      </main>
    </Grid>
  );
};

export default AuthLayout;
